import {
   FormContent,
   FormLabel,
   Notification,
   NotificationSize,
   NotificationType,
   StyledFlex,
} from '@dreryk/react-components';

import { translationKeys } from '../translations';

import { NfzMfaTotpField } from './fields/NfzMfaTotpField';
import { NfzMfaFormController, NfzMfaTotpErrorSetter } from './NfzMfaForm.types';
import { StyledNfzMfaTotpRow } from './NfzMfaForm.styled';
import { useNfzMfaForm } from './NfzMfaForm.hooks';

type NfzMfaFormRenderProps = Pick<NfzMfaFormController, 'handleSubmit'> & {
   setMfaTotpError: NfzMfaTotpErrorSetter;
};

type NfzMfaFormProps = {
   readonly children: (renderProps: NfzMfaFormRenderProps) => JSX.Element;
};

export const NfzMfaForm = (props: NfzMfaFormProps): JSX.Element => {
   const { register, handleSubmit, setMfaTotpError } = useNfzMfaForm();

   return (
      <form noValidate autoComplete={'off'}>
         <FormContent testId={'nfzMfaLogin'}>
            <StyledFlex direction={'column'} gap={8}>
               <StyledFlex direction={'column'} gap={4}>
                  <FormLabel label={translationKeys.mfaModal.totpFieldLabel} testId={'mfaTotp'} compact nowrap />
                  <StyledNfzMfaTotpRow gap={8} alignItems={'flex-start'}>
                     <NfzMfaTotpField register={register} />
                     {props.children({
                        handleSubmit: handleSubmit,
                        setMfaTotpError: setMfaTotpError,
                     })}
                  </StyledNfzMfaTotpRow>
               </StyledFlex>
               <Notification
                  testId={'nfzMfaTotpHint'}
                  type={NotificationType.INFO}
                  size={NotificationSize.SMALLER}
                  label={translationKeys.mfaModal.totpFieldHint}
               />
            </StyledFlex>
         </FormContent>
      </form>
   );
};
